<template>
  <div class="action__section__filter action__section__list action__section__list--form">
    <div class="item item__key input-custom-icon">
      <input 
        v-model.lazy="keyword"
        v-debounce="300"
        type="text"
        placeholder="Tìm kiếm"
        class="primary-color-txt bg-color-light border-rd-20 font-size-15 form-h30 border-0 full-width"
      >
      <i class="icon-search font-size-16 primary-color"></i>
    </div>
    <div class="item-row action__section__row display-flex-center">
      <div class="item item__class select-custom">
        <select class="primary-color-txt border-rd-20 font-size-15 form-h30 bg-color-light border-0 full-width" @change="getSubjects">
          <option value="0">Lớp - Tất cả</option>
          <option v-for="item of classes" :key="item.classId" :value="item.classId">{{ item.className }}</option>
        </select>
        <i class="icon-arrow-down font-size-13 primary-color"></i>
      </div>
      <div class="item item__subject select-custom">
        <select class="primary-color-txt border-rd-20 font-size-15 form-h30 bg-color-light border-0 full-width" @change="filterBySubject">
          <option value="0">Môn - tất cả</option>
          <option v-for="item of subjects" :key="item.subjectId" :value="item.subjectId">{{ item.subjectName }}</option>
        </select>
        <i class="icon-arrow-down font-size-13 primary-color"></i>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import { STORE_KEY } from './../../_store/constants'
import debounce from "@/directives/debounce"

export default {
  name: 'SidebarFilter',
  directives: { debounce },
  props: {
    fileType: Number
  },
  data () {
    return {
      keyword: '',
      subjects: []
    }
  },
  computed: {
    ...mapState(STORE_KEY, ['classes', 'paramsSearchMediaDetail'])
  },
  watch: {
    keyword: 'searchByKeyword'
  },
  methods: {
    ...mapActions(STORE_KEY, ['acSetParamSearchMediaDetail']),

    searchByKeyword (val) {
      this.acSetParamSearchMediaDetail({...this.paramsSearchMediaDetail, keyword: val, pageIndex: 1})
    },

    getSubjects (evt) {
      let value = parseInt(evt.target.value) || 0
      if (value === 0 ) {
        this.subjects = []
      } else {
        let indexClassCurr = this.classes.findIndex(cl => cl.classId === value)
        this.subjects = indexClassCurr > -1 ? this.classes[indexClassCurr].subjects : []
      }
      // this.handleEmitParam()
      this.acSetParamSearchMediaDetail({...this.paramsSearchMediaDetail, classId: value, pageIndex: 1})
    },

    filterBySubject (evt) {
      let value = parseInt(evt.target.value) || 0
      this.acSetParamSearchMediaDetail({...this.paramsSearchMediaDetail, subjectId: value, pageIndex: 1})
    },

    handleEmitParam () {
      this.$emit('search', this.paramsSearchMediaDetail)
    }
  }
}
</script>

<style lang="scss" scoped>
  
</style>
